import { useCallback, useMemo, useState } from 'react';

import {
  useAutoSearchHSACombineAccounts,
  useManualSearchHSACombineAccounts,
} from '../queries/useSearchHSACombineAccounts.query';
import { CombineHSASectionType } from '../types/combineHSA.types';

interface Params {
  accountNumber: string;
  employeeId: string;
  ssn: string;
  firstName?: string;
  lastName?: string;
  sectionType: CombineHSASectionType;
}

export const useCombineHSASection = ({ accountNumber, employeeId, ssn, firstName, lastName, sectionType }: Params) => {
  const [searchValue, setSearchValue] = useState('');

  const { data: autoSearchedAccounts, isLoading: isAutoLoading } = useAutoSearchHSACombineAccounts({
    accountNumber,
    employeeId,
    ssn,
    firstName,
    lastName,
    sectionType,
  });
  const { data: manuallySearchedAccounts, enabled: isManualSearchEnabled, isLoading: isManualLoading } = useManualSearchHSACombineAccounts({
    accountNumber,
    employeeId,
    ssn,
    searchValue,
    sectionType,
  });

  const isLoading = useMemo(
    () => isManualSearchEnabled ? isManualLoading : isAutoLoading,
    [isManualSearchEnabled, isManualLoading, isAutoLoading]
  );
  const accounts = useMemo(
    () => isManualSearchEnabled ? manuallySearchedAccounts : autoSearchedAccounts,
    [isManualSearchEnabled, manuallySearchedAccounts, autoSearchedAccounts]
  );

  const handleSearchChange = useCallback((value: string) => setSearchValue(value), []);

  return {
    accounts,
    isLoading,
    isManualSearchEnabled,
    searchValue,
    handleSearchChange,
  };
};
